import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import axios from '../../util/Api';

const PositionForm = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/master/positions`;
    axios.get(url).then(resp => {
      setPositions(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <>
      <Select
        defaultValue={formik.values.position} onChange={value => formik.setFieldValue("position", value)}
        placeholder="Pilih level jabatan"
        loading={loading}
      >
        {positions.map((item, key) => {
          return <Select.Option value={item.id} key={`position-${key}`}>{item.name}</Select.Option>
        })}
      </Select>
      <ErrorMessage component="div" name="position" className="gx-mt-2 gx-text-red" />
    </>
  );
}

export default PositionForm;